import { API } from "@/lib/api";
import { Download } from "lucide-react";
import { useState } from "react";

/**
 * QRCode — displays a QR pointing to `data` (defaults to site root).
 * `showDownload` renders a download button next to it.
 */
export default function QRCode({
  data,
  size = 220,
  boxSize = 12,
  bg = "white",
  logo = 1,
  showDownload = false,
  label = "Scannez pour visiter le site",
  filename = "das-simao-auto-qrcode.png",
  testId = "qr-code",
}) {
  const [loaded, setLoaded] = useState(false);
  const url = `${API}/qr?data=${encodeURIComponent(data)}&size=${boxSize}&bg=${bg}&logo=${logo}`;
  const dlUrl = `${API}/qr?data=${encodeURIComponent(data)}&size=32&bg=white&logo=1&download=1&filename=${encodeURIComponent(filename)}`;

  return (
    <div
      data-testid={testId}
      className="inline-flex flex-col items-center gap-4"
    >
      <div
        className="p-3 bg-white rounded-sm relative"
        style={{ width: size + 24, height: size + 24 }}
      >
        {!loaded && (
          <div className="absolute inset-3 animate-pulse bg-gray-200" />
        )}
        <img
          src={url}
          alt="QR code"
          width={size}
          height={size}
          onLoad={() => setLoaded(true)}
          className="block"
        />
      </div>
      {label && (
        <div className="text-[10px] tracking-[0.35em] gold uppercase text-center max-w-[220px]">
          {label}
        </div>
      )}
      {showDownload && (
        <a
          href={dlUrl}
          data-testid={`${testId}-download`}
          className="btn-outline-gold inline-flex items-center gap-2 text-xs"
        >
          <Download size={14} /> Télécharger le QR
        </a>
      )}
    </div>
  );
}
